/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */
import { BaseSyntheticEvent, FormHTMLAttributes, PropsWithChildren, useEffect, useState } from 'react';
import styles from '../../styles/FormLayout.module.css';
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import { FieldValues, FormProvider, SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form';

export type CustomFormContainerProps<T extends FieldValues = FieldValues> = PropsWithChildren<UseFormProps<T> & {
    onSuccess?: SubmitHandler<T>
    FormProps?: FormHTMLAttributes<HTMLFormElement>
    handleSubmit?: (e: BaseSyntheticEvent<T>) => Promise<void> | void
    formContext: UseFormReturn<T>
}>

export default function CustomFormContainer<TFieldValues extends FieldValues = FieldValues>({
    handleSubmit,
    children,
    FormProps,
    formContext,
    onSuccess,
    ...useFormProps
}: PropsWithChildren<CustomFormContainerProps<TFieldValues>>) {
 

 
  return (
        <FormProvider {...formContext}>
            <form
                noValidate
                {...FormProps}
                // @ts-ignore
                onSubmit={
                    !!handleSubmit
                        ? handleSubmit
                        : onSuccess
                            ? formContext.handleSubmit(onSuccess)
                            : () => console.log('submit handler is missing')
                }>
                {children}
            </form>
        </FormProvider>
    
  );
};
